import script from "./MatchesView.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchesView.vue?vue&type=script&setup=true&lang=js"

import "./MatchesView.vue?vue&type=style&index=0&id=2831930a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2831930a"]])

export default __exports__